import { useInstance } from '@meraki-internal/react-dependency-injection';
import { IChecklist, ISupportGroupKey } from '../caremap/ICareMap';
import { CareMapState } from '../caremap/CareMapState';
import { HtmlChecklist } from './HtmlChecklist';

export const Checklists: React.FC<{ checklists: IChecklist[]; supportGroupKey: ISupportGroupKey  }> = ({ checklists, supportGroupKey }) => {
    const careMapState = useInstance(CareMapState);
    // we don't subscribe b/c downsteam owns the html and we don't update it

    return (
        <>
            {checklists.map((checklist, i) => (
                <HtmlChecklist
                    key={i}
                    checkList={checklist}
                    supportGroupKey={supportGroupKey}
                    onChanged={html => {
                        checklist.html = html;
                        careMapState.enqueueSave();
                    }}
                />
            ))}
        </>
    );
};
